import { Box, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { Color, FontStyle, JobDisplays } from "../../../constants";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
} from "../../../utils/jobUtils";
import {
  ResourceBody,
  ResourceContainer,
  ResourceHeader,
} from "../ResourcePanel";

const resource1 = [
  [
    "div",
    "A job interview can be a challenging and nerve-wracking experience, but with proper preparation and mindset, you can excel and impress your interviewers. Here’s how to ace your next job interview by straight from the source (ex-recruiters at Fortune 500 companies, aka the Fetti team):",
  ],
  ["x-div", ""],
  // ["i", "By ex-recruiters @ Meta, Google, and more!"],
  [
    "li-1",
    () => (
      <span>
        <b>Treat it Like an Exam: </b>Interviews are an exercise in preparation.
        Approach them like you would an exam, and prepare accordingly.
      </span>
    ),
  ],
  [
    "li-2",
    () => (
      <span>
        <b>Know Your Role: </b>If you're interviewing for a general position,
        hone your best skills and language. If it's a specific role, research
        and understand what they're looking for.
      </span>
    ),
  ],
  [
    "li-3",
    () => (
      <span>
        <b>Attend Supplementary Sessions: </b>Attend any supplementary sessions
        or auxiliary information from the company in question. Blog posts from
        engineers at the company, press releases, or communications can provide
        valuable insights.
      </span>
    ),
  ],
  [
    "li-4",
    () => (
      <span>
        <b>Get Information Ahead of Time: </b>Get as much information from your
        recruiter ahead of time as possible. Know the role you're interviewing
        for, who you're interviewing with, and what they're highlighting.
      </span>
    ),
  ],
  [
    "li-5",
    () => (
      <span>
        <b>Be Honest: </b>It's better to say "I don't know" than fake your way
        through something you're unfamiliar with. Be honest and upfront about
        your knowledge and experience.
      </span>
    ),
  ],
  [
    "li-6",
    () => (
      <span>
        <b>Speak Your Mind: </b>Let your interviewer in on your thought process
        and reasoning. Show them how you approach problem-solving and critical
        thinking.
      </span>
    ),
  ],
  [
    "li-7",
    () => (
      <span>
        <b>Let Your Enthusiasm Shine: </b>Show your passion and enthusiasm for
        the role and the company. Let them know why you're interested and what
        motivates you.
      </span>
    ),
  ],
  [
    "li-8",
    () => (
      <span>
        <b>Research the Company and Role: </b>Research the company and role, and
        develop thoughtful, insightful questions. Show that you're paying
        attention and understand their mission and values.
      </span>
    ),
  ],
  [
    "li-9",
    () => (
      <span>
        <b>Find Your Authentic Voice: </b>Be yourself and be memorable. Find
        your authentic voice and let your personality and skills shine through.
      </span>
    ),
  ],
  [
    "li-10",
    () => (
      <span>
        <b>Prepare, Prepare, Prepare: </b>Write down notes you've taken and have
        cues on hand. Talk through your thought process and ask good,
        thoughtful, and prepared questions.
      </span>
    ),
  ],
  [
    "li-11",
    () => (
      <span>
        <b>Take Deep Breaths: </b>Take deep breaths and try to stay calm and
        composed. Remember that they're interviewing you because they want you
        and are interested in you.
      </span>
    ),
  ],
];

const resourceDescription = {
  showIdx: 3,
  lastElementShown: () => (
    <span>
      <b>Know Your Role: </b>If you're interviewing for a general pos...
    </span>
  ),
  list: [...resource1],
};

const InterviewResource = ({
  job,
  fullHeight = false,
  showDescriptionOverlay,
}) => {
  const [showMore, setShowMore] = React.useState(false);
  // if (!job) return null;
  return (
    <ResourceContainer
      fullHeight={fullHeight}
      showDescriptionOverlay={showDescriptionOverlay}>
      <ResourceHeader
        title="How to Crush Your Next Job Interview"
        subtitle="By former Groupon, Linkedin, and Google Recruiters at Fetti"
      />
      <ResourceBody data={resourceDescription} />
      {/* Bottom row with url + apply button */}
      {/* <Box sx={{ ...jobButtonStyle, width: "100%", maxWidth: "100%" }}>
        <DownloadTemplateWrapper href={JobDownloads.resumeTemplate}>
          Download Our Free Resume Template
        </DownloadTemplateWrapper>
      </Box> */}
    </ResourceContainer>
  );
};

export default InterviewResource;
